import owd from '../owd/owd';
import browser from '../owd/utils/browser';

export default class CustomCursor extends owd.Module {
    constructor(app) {
        super(app);

        this.cursor = document.createElement('div');
        this.cursor.classList.add('cursor');
        this.cursor.innerHTML = '<span class="cursor-inner"></span>';

        this.injected = false;
        this.isSupported = !browser.isIOS() && !browser.isIOSChrome() && !browser.isIOSFirefox() && !browser.isAndroid();
        this.isEnabled = !!this.isSupported;

        this.elementEnterMove = this.elementEnterMove.bind(this);
        this.elementLeave = this.elementLeave.bind(this);
        this.elementModifierChanged = this.elementModifierChanged.bind(this);

        if (this.isEnabled) {
            document.documentElement.classList.add('no-cursor');
            this.bind();
        }
    }

    bind() {
        if (!this.bindOnce) {
            this.bindOnce = true;

           

            document.documentElement.addEventListener('mousemove', (e) => {
                this.show();
                this.up();

                const transform = `translate(${e.clientX}px, ${e.clientY}px)`;

                this.cursor.style.transform = transform;
                this.cursor.style.webkitTransform = transform;
            });

            document.body.addEventListener('touchstart', (e) => {
                this.hide();
                this.up();
            });

            document.body.addEventListener('touchend', (e) => {
                this.hide();
                this.up();
            });

            document.body.addEventListener('touchmove', (e) => {
                this.hide();
                this.up();
            });

            document.body.addEventListener('mouseout', (e) => {
                if (e.relatedTarget === null || e.relatedTarget === document.documentElement) {
                    this.hide();
                    this.up();
                }
            });

            document.documentElement.addEventListener('mousedown', (e) => {
                this.down();
            });

            document.documentElement.addEventListener('mouseup', (e) => {
                this.up();
            });

        }
    }

    down() {
        if (!this.isPressed) {
            this.cursor.classList.add('is-pressed');
            this.isPressed = true;
        }
    }

    up() {
        if (this.isPressed) {
            this.cursor.classList.remove('is-pressed');
            this.isPressed = false;
        }
    }

    disable() {
        if (this.isEnabled) {
            document.documentElement.classList.remove('no-cursor');
            this.isEnabled = false;
            this.hide();
        }
    }

    enable() {
        if (!this.isEnabled && this.isSupported) {
            document.documentElement.classList.add('no-cursor');
            this.bind();
            this.isEnabled = true;
        }
    }

    show() {
       
        if (!this.injected && this.isEnabled) {
             //console.log('show', this.cursor);
             
            document.body.appendChild(this.cursor);
            this.cursor.classList.add('is-visible');
            this.injected = true;
        }
    }

    hide() {
        if (this.injected) {
            document.body.removeChild(this.cursor);
            this.cursor.classList.remove('is-visible');
            this.injected = false;
        }
    }

    elementEnterMove(e) {
        
        if (e.currentTarget.dataset.cursorMode) {
            this.setMode(e.currentTarget.dataset.cursorMode);
        }

        if (e.currentTarget.dataset.cursorTheme) {
            this.setTheme(e.currentTarget.dataset.cursorTheme);
        }

        this.currentModifier = e.currentTarget;
    }

    elementModifierChanged(e) {
        if (e.currentTarget === this.currentModifier) {
            if (e.currentTarget.dataset.cursorMode) {
                this.setMode(e.currentTarget.dataset.cursorMode);
            }

            if (e.currentTarget.dataset.cursorTheme) {
                this.setTheme(e.currentTarget.dataset.cursorTheme);
            }
        }
    }

    elementLeave(e) {
        if (e.currentTarget.dataset.cursorMode) {
            this.resetMode();
        }

        if (e.currentTarget.dataset.cursorTheme) {
            this.resetTheme();
        }

        if (this.currentModifier === e.currentTarget) {
            this.currentModifier = null;
        }
    }

    addModifier(element) {
        element.addEventListener('mouseenter', this.elementEnterMove);
        element.addEventListener('mousemove', this.elementEnterMove);
        element.addEventListener('mouseleave', this.elementLeave);
        element.addEventListener('cursor-modifier-changed', this.elementModifierChanged);
    }

    removeModifier(element) {
        if (this.currentModifier === element) {
            this.resetMode();
            this.resetTheme();
            this.currentModifier = null;
        }

        element.removeEventListener('mouseenter', this.elementEnterMove);
        element.removeEventListener('mousemove', this.elementEnterMove);
        element.removeEventListener('mouseleave', this.elementLeave);
        element.removeEventListener('cursor-modifier-changed', this.elementModifierChanged);
    }

    setMode(mode) {
        
        if (this.mode !== mode) {
            this.cursor.dataset.mode = mode;
        }
    }

    resetMode() {
        this.cursor.dataset.mode = null;
    }

    setTheme(theme) {
        if (this.theme !== theme) {
            this.cursor.dataset.theme = theme;
        }
    }

    resetTheme() {
        this.cursor.dataset.theme = null;
    }
}
